import { Prop, Component, Host, h, JSX } from '@stencil/core'

@Component({
    tag: 'zr-usp',
    styleUrl: 'zr-usp.scss',
    scoped: true,
})

/**
 * ZooRoyal usp component.
 */
export class ZrUsp {

    /**
     * List of usps with icons.
     */
    @Prop() data = []

    /**
     * Renders the component.
     *
     * @returns {JSX.Element} - The rendered component.
     */
    render(): JSX.Element {
        return (
            <Host>
                <div class="zr-usp">
                    <ul class="zr-usp__list">
                        {this.data.map(usp => (
                            usp.text && usp.icon &&
                                <li class="zr-usp__list-item">
                                    <p class={`zr-usp__icon--${usp.icon}`}>{usp.text}</p>
                                </li>
                        ))}
                    </ul>
                </div>
            </Host>
        )
    }
}
